export interface IStateLoading {
    loading: boolean;
}

export interface ITableEntity {
    partitionKey: string;
    rowKey: string;
    timestamp?: Date;
}

export interface IColumn {
    id: number;
    inColName: string;
    inColType: string;
    nullable: boolean;
    updatable: boolean;
    dbColName: string;
    maxWidth: number;
    escapeNull: boolean;
    inEdit: boolean;
    isNew: boolean;
    isRemoved?: boolean;
}

export interface IDataLoaderConfig {
    disabled: boolean;
    archive: string;
    dbName: string;
    tableName: string;
    colSep: string;
    updateOnlyLatest: boolean;
    truncateTable: boolean;
    columns: IColumn[];
    columnlist: string;
}

interface IFileSource {
    sourceKey: string;
    sourceName: string;
    sourceFolder: string;
    sourceArchive: string;
    removeFile: boolean;
    regex: string;
}

export interface IFileDestination {
    id: number;
    destinationType: string;
    destination: string;
    folders: string;
    disabled: boolean;
    inEdit: boolean;
    isNew: boolean;
    isRemoved?: boolean;
}

interface IFileLoaderConfig {
    fileName: string;
    fileType: string;
    downloadType: string;
    frequency: string;
    source: IFileSource;
    destinations: IFileDestination[];
}

export interface IConfigurationEntity extends ITableEntity {
    user?: string;
    disabled: boolean;
    muleDisabled: boolean;
}

export interface IConfigurationData extends IConfigurationEntity {
    isNew: boolean;
    dataConfig?: IDataLoaderConfig;
    fileConfig: IFileLoaderConfig;
}

export interface AuthorizedProps {
    isAuthenticated: boolean;
    user: any;
    authButtonMethod: any;
    getAccessToken: any;
}

export interface ILookupItem {
    name: string;
    properties: string;
}

export interface IDropdownData {
    name: string;
    value: string | number;
}

export interface IValidationData {
    errors: string[];
    warnings: string[];
}

export interface IDataLoaderInput {
    id?: string;
    name: string;
    path: string;
    isFolder?: boolean;
    ignoreArchiveCheck: boolean;
}

export enum IServiceState {
    Enabled = "Enabled",
    Disabled = "Disabled"
}

export interface IServiceStateOutput {
    state: IServiceState;
}


export interface IFileStatus extends ITableEntity {
    filename: string;
    retries: number;
    inserted: number;
    updated: number;
    rejected: number;
    committed: number;
    status: string;
    startedDateTime: Date;
    updatedDateTime: Date;
    elapsed: string;
    length: number;
}

export interface IFileHistory extends ITableEntity {
    downloadDateTime: Date;
    dispatched: boolean;
}

export interface IWorkingFile extends ITableEntity {
    filename: string;
}

export interface IFileArchive extends ITableEntity {
    path: string;
}

export interface IFileStatusReport {
    fileStatus?: IFileStatus;
    fileHistory?: IFileHistory;
    fileArchive?: IFileArchive;
    fileConfig?: IFileLoaderConfig;
    dataConfig?: IDataLoaderConfig;
}

export interface ISecret {
    hint: string;
    title: string;
    name: string;
    value: string;
}

export interface IAuditTracker extends ITableEntity {
    filename: string;
    correlationId: string;
    dbWriteStatus: string;
    fileSize: number;
    fileWriteStatus: string;
    lastUpdatedBy: string;
    recordsInserted: number;
    recordsUpdated: number;
    recordsFailed: number;
    totalRecords: number;
    updateDateTime: Date;
    downloadedFileName: string;
    downloadedFileWriteStatus: string;
    mergeRecords: number;
}

